/* eslint-disable jsx-a11y/anchor-is-valid */
import { Hooks } from 'providers';
import React, {
  LegacyRef,
  MouseEvent,
  MutableRefObject,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import DeleteBoard from 'components/layouts/modal/DeleteBoard';

import { checkIsAdmin } from 'helpers/checkIsAdmin';
import { useOuterClick } from 'providers/OutsideClick';

import { HIT_RESET } from 'redux/actions/auth';
import { useDuplicateBoardMutation, useListMemberBoardQuery } from 'components/board/hooks/useBoard';
import {
  VALIDATION_COMPANY,
  VALIDATION_DASHBOARD,
} from 'redux/actions/validationRole';

import Button from 'components/_parts/atoms/button';
import moment from 'helpers/dayjsWrapper';
import IconCustom from 'components/_parts/atoms/icon';
import { HIT_LIST_MEMBER } from 'redux/actions/company';

type ArgsReducer = {
  board: {
    data: {
      description: string;
      board_id: string;
      name: string;
      validation_member: {
        user_type: string;
        error: string;
      };
      visibility_status_ket: string;
      last_update: string;
    }[];
  };
  loading: {
    trigger: boolean;
  };
  auth: {
    role: {
      user_type: string;
    };
  };
};

type Props = {
  setModalAdd: (e: boolean) => void;
  setModalInfo: (e: boolean) => void;
  setDataInfo: (e: {}) => void;
  getPosition: (e: MouseEvent) => void;
};

function CardBoardComponent(props: Readonly<Props>) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { board, trigger } = useSelector((state: ArgsReducer) => ({
    board: state?.board?.data,
    trigger: state?.loading?.trigger,
    validationBoard: state?.auth?.role?.user_type,
  }));
  const {
    setModalDelete,
    keywordBoard,
    setBoardNow,
    setModal,
  }: {
    setModalDelete: (e: boolean) => void;
    keywordBoard: string;
    setBoardNow: (e: string) => void;
    setModal: (e: boolean) => void;
  } = useContext(Hooks);
  const [activeBoard, setActiveBoard] = useState('');
  const [memberFetchBoardId, setMemberFetchBoardId] = useState<string | undefined>();

  const duplicateBoardMutation = useDuplicateBoardMutation();
  useListMemberBoardQuery(memberFetchBoardId, undefined, Boolean(memberFetchBoardId));

  const innerRef: MutableRefObject<undefined> = useOuterClick(() => {
    if (activeBoard) {
      setActiveBoard('');
    }
  });
  useEffect(() => {
    dispatch({
      type: VALIDATION_COMPANY,
    });
  }, []);

  useEffect(() => {}, [keywordBoard]);

  const labelBoard = useCallback((item: string) => {
    if (item === 'Private') {
      return t('board.private');
    }
    return t('board.public');
  }, [t]);

  return (
    <>
      {board.map((val, x) => {
        const boardId = val.board_id;
        const indexValue = encodeURIComponent(x);
        const linkUrl = `/detail-board/${boardId}_${indexValue}`;
        return (
          <div
            key={val.board_id}
            className={`col-lg-6 col-xl-4 d-flex test ${
              keywordBoard !== undefined
              && !val.name?.toLowerCase().includes(keywordBoard?.toLowerCase())
                ? 'rBoardHide'
                : ''
            }
              ${val.validation_member?.error && ' rBoardHide'}
              `}
            style={{ maxHeight: '190px', height: '100%' }}
          >
            <div
              className="card flex-fill rCard shadowMonitor"
            >
              <div className="card-header pb-1">
                <div
                  className="card-actions float-right d-flex justify-content-center"
                  style={{ gap: '8px' }}
                >
                  <button
                    type="button"
                    className="btn btn-pill btn-sm pointerOff"
                    style={{
                      backgroundColor: '#9AFF5B',
                      color: '#FFFF',
                      fontSize: '10px',
                    }}
                  >
                    {labelBoard(val.visibility_status_ket)}
                  </button>

                  <div
                    aria-hidden="true"
                    className="dropdown"
                    style={{
                      cursor: !checkIsAdmin(val.validation_member?.user_type)
                        ? 'not-allowed'
                        : 'pointer',
                      pointerEvents: !checkIsAdmin(val.validation_member?.user_type)
                        ? 'none'
                        : 'auto',
                    }}
                    onClick={() => {
                      setActiveBoard(val.board_id);
                    }}
                  >
                    <IconCustom
                      typeIcon="setting"
                      style={{
                        stroke: !checkIsAdmin(val.validation_member?.user_type)
                          ? '#b7b7b7'
                          : '#000',
                      }}
                    />
                    <div
                      ref={innerRef as unknown as LegacyRef<HTMLDivElement>}
                      className={`dropdown-menu dropdown-menu-right board-p ${activeBoard === val.board_id ? 'show' : ''}`}
                    >
                      <button
                        type="button"
                        className="dropdown-item"
                        onClick={() => {
                          dispatch({
                            type: HIT_LIST_MEMBER,
                          });
                          dispatch({
                            type: VALIDATION_DASHBOARD,
                            payload: {
                              board_id: val.board_id,
                            },
                            types: 'dashboard',
                          });
                          dispatch({
                            type: HIT_LIST_MEMBER,
                            payload: {
                              board_id: val.board_id,
                            },
                            types: 'dashboard',
                          });
                          setMemberFetchBoardId(val.board_id);
                          localStorage.setItem(
                            'deleteMember_boardId',
                            val.board_id,
                          );
                          localStorage.setItem('board_id', val.board_id);
                          props?.setModalInfo(true);
                          props?.setDataInfo(val);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-info align-middle mr-2 rInfo"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <line x1="12" y1="16" x2="12" y2="12" />
                          <line x1="12" y1="8" x2="12" y2="8" />
                        </svg>
                        {t('board.info')}
                      </button>
                      <button
                        type="button"
                        className={`dropdown-item ${
                          !checkIsAdmin(val.validation_member?.user_type)
                            ? 'd-none'
                            : ''
                        }`}
                        onClick={() => {
                          duplicateBoardMutation.mutate({
                            board_id: val.board_id,
                            publish_status: '0',
                          });
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-copy align-middle mr-2 rDuplicate"
                        >
                          <rect
                            x="9"
                            y="9"
                            width="13"
                            height="13"
                            rx="2"
                            ry="2"
                          />
                          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                        </svg>
                        {t('board.duplicate')}
                      </button>
                      <div className="dropdown-divider" />
                      <button
                        type="button"
                        className={`dropdown-item ${
                          !checkIsAdmin(val.validation_member?.user_type)
                            ? 'd-none'
                            : ''
                        }`}
                        onClick={() => {
                          setModalDelete(true);
                          setModal(true);
                          setBoardNow(val.board_id);
                        }}
                        data-toggle="modal"
                        data-target="#deleteModal"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-trash-2 align-middle mr-2 rRemove"
                        >
                          <polyline points="3 6 5 6 21 6" />
                          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
                          <line x1="10" y1="11" x2="10" y2="17" />
                          <line x1="14" y1="11" x2="14" y2="17" />
                        </svg>
                        {t('board.delete')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="list-board"
                aria-hidden="true"
                className="card-body px-4 py-2"
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  dispatch({
                    type: HIT_RESET,
                  });
                  dispatch({
                    type: VALIDATION_DASHBOARD,
                    payload: {
                      board_id: val.board_id,
                    },
                    types: 'dashboard',
                  });
                  history.push('/dashboard');
                  localStorage.setItem('board_id', val.board_id);
                  localStorage.setItem('board_name', val.name);
                  localStorage.setItem('board_index', String(x));
                }}
              >
                <div className="row d-flex align-items-center">
                  <div className="col-12">
                    <p
                      className="align-items-center rStructureTitle mb-0"
                      dangerouslySetInnerHTML={{
                        __html: val.name,
                      }}
                      style={{
                        fontSize: '14px',
                        fontWeight: '800',
                        lineHeight: '14px',
                        maxWidth: '90%',
                        padding: '1px 0px',
                      }}
                    />
                    {/* </a> */}
                    {val.description !== '' && (
                      <div
                        id="textDetailJobdesc"
                        className="rCardShortdesc mt-1 mb-0 lineClamp3"
                        dangerouslySetInnerHTML={{
                          __html: val.description || '.',
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              {/* </Link> */}

              <div className="card-footer pt-0" style={{ alignSelf: 'normal' }}>
                <p className="textMonitorning mb-0">
                  {t('board.last_update')}
                  {' '}
                  <span style={{ fontWeight: '800' }}>
                    {moment(val.last_update).local().format('DD MMM YYYY')}
                  </span>
                </p>
              </div>
            </div>
            <DeleteBoard for="board" />
          </div>
        );
      })}
      <div className="col-lg-6 col-xl-4 d-flex">
        <div
          className="card flex-fill addCard"
          style={{ maxHeight: '160px' }}
        >
          <div className="card-body d-flex align-items-center justify-content-center">
            <div
              aria-hidden="true"
              className="col-12"
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                props?.setModalAdd(true);
                props?.getPosition(e);
              }}
            >
              <p
                className="textAddCard mb-4"
                data-toggle="modal"
                data-target="#addBoardModal"
              >
                {t('board.create')}
              </p>

              <Button
                style={{
                  width: '28px',
                  height: '28px',
                  background: '#9AFF5B',
                  margin: 'auto',
                }}
                icon="create"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const CardBoard = React.memo(CardBoardComponent);
export default CardBoard;

export const publishStat = (val: number) => {
  switch (val) {
    case 0:
      return 'Draft';

    case 1:
      return 'Review';

    case 2:
      return 'Accepted';

    case 3:
      return 'Archived';

    default:
      return 'Draft';
  }
};
